import React, { useEffect } from 'react';
import { updateAdPaymentStatus } from '../firebase-service';

const PaymentCancel: React.FC = () => {
  useEffect(() => {
    // Handle payment cancellation
    const handlePaymentCancel = async () => {
      console.log('Payment cancel page loaded');
      console.log('Current URL:', window.location.href);
      
      // Get ad ID and other parameters from URL
      const urlParams = new URLSearchParams(window.location.search);
      const adId = urlParams.get('ad_id') || localStorage.getItem('current_ad_id');
      const sessionId = urlParams.get('session_id');
      const paymentMethod = urlParams.get('payment_method');
      const paymentId = urlParams.get('payment_id'); // NOWPayments parameter
      
      console.log('URL params:', { adId, sessionId, paymentMethod, paymentId });
      
      // Only process if we have proper payment provider parameters
      const hasStripeParams = paymentMethod === 'stripe' && sessionId;
      const hasCryptoParams = paymentMethod === 'crypto'; // Crypto doesn't need payment_id in URL
      
      if (!hasStripeParams && !hasCryptoParams) {
        console.log('⚠️ No valid payment provider parameters found - not processing cancellation');
        console.log('This appears to be a direct page visit, not a payment provider redirect');
        return;
      }
      
      if (adId) {
        try {
          // Determine payment method and details
          const method = paymentMethod === 'stripe' ? 'card' : 'crypto';
          const details = paymentMethod === 'stripe' ? {
            type: 'stripe_checkout' as const,
            sessionId: sessionId || '',
            error: 'Payment cancelled by user',
            failedAt: new Date().toISOString()
          } : {
            type: 'cryptocurrency' as const,
            error: 'Payment cancelled by user',
            failedAt: new Date().toISOString()
          };

          await updateAdPaymentStatus(adId, {
            status: 'payment_failed',
            method,
            details
          });
          console.log('❌ Payment status updated to cancelled for ad:', adId);
        } catch (error) {
          console.error('Error updating payment status:', error);
        }
      } else {
        console.warn('No ad ID found in URL parameters or localStorage');
      }
    };

    handlePaymentCancel();
  }, []);

  return (
    <div className="payment-result-page">
      <div className="payment-result-container cancel-page">
        <div className="payment-result-header">
          <div className="payment-result-icon">❌</div>
          <h1 className="payment-result-title">Payment Cancelled</h1>
          <p className="payment-result-subtitle">
            Your payment was cancelled. No charges were made to your account.
          </p>
        </div>
        
        <div className="payment-result-body">
          <div className="payment-result-details">
            <h3>What happened?</h3>
            <ul>
              <li data-icon="💳">Your payment was not processed</li>
              <li data-icon="📄">Your ad was not submitted</li>
              <li data-icon="🔒">No charges were made</li>
              <li data-icon="🗄️">Your ad draft is still saved</li>
              <li data-icon="🔄">You can try again anytime</li>
            </ul>
          </div>
          
          <div className="payment-result-actions">
            <button 
              className="payment-result-button"
              onClick={() => window.location.href = '/'}
            >
              <span>🚀</span>
              Try Again
            </button>
            <button 
              className="payment-result-button secondary"
              onClick={() => window.location.href = '/'}
            >
              <span>🏠</span>
              Back to Form
            </button>
          </div>
        </div>
        
        <div className="payment-result-footer">
          <p>
            Need help? Contact us <a href="https://t.me/neodia_ad" target="_blank" rel="noopener noreferrer">@neodia_ad</a> in telegram - reply in minutes
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel; 